"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Product = void 0;
var gql = String.raw;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
exports.Product = {
  name: 'Product',
  useConversation: true,
  useFollowers: true,
  useModerators: true,
  useConnections: true,
  usePublishStatus: true,
  useSpaces: true,
  useSlices: true,
  autoRoutes: ['details', 'list', 'update', 'create'],
  usePlatformActivity: true,
  platformActivity: {
    tab: 'own'
  },
  list: {
    banner: {
      content: 'Explore notable {{PRODUCTS}} in the space'
    },
    queryFields: "\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      description { id text html }\n    "
  },
  form: {
    fieldsMemoize: false,
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'media'
    }, {
      name: 'library'
    }, {
      name: 'activity'
    }, {
      name: 'community'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'description'
      },
      url: {
        type: 'url',
        fieldSet: 'overview'
      },
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'ProductType',
        fieldSet: 'overview'
      },
      features: {
        type: 'linkedMultiple',
        entityTypeName: 'ProductFeature',
        fieldSet: 'overview'
      },
      services: {
        type: 'linkedMultiple',
        entityTypeName: 'Service',
        fieldSet: 'overview'
      },
      banner: {
        type: 'linked',
        entityTypeName: 'Banner',
        fieldSet: 'overview'
      },
      roles: {
        type: 'linkedTable',
        entityTypeName: 'ProductRole',
        label: '{{PEOPLE}}',
        description: "Are there any other key {{PEOPLE}} involved in this {{PRODUCT}}?",
        fieldSet: 'community'
      },
      organisationRoles: {
        type: 'linkedTable',
        entityTypeName: 'OrganisationProductRole',
        label: '{{ORGANISATIONS}}',
        description: "Are there any {{ORGANISATIONS}} involved in this {{PRODUCT}}?",
        fieldSet: 'community'
      },
      images: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        fieldSet: 'library'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        fieldSet: 'library'
      },
      documents: {
        type: 'linkedMultiple',
        entityTypeName: 'Document',
        fieldSet: 'activity'
      }
    })
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      id\n      name\n      slug\n      description { id text html }\n      startDate\n      endDate\n      url\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n\n      banner { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      links { ...EntityValueFields }\n      documents { ...EntityValueFields }\n      quotes { ...EntityValueFields }\n      roles { ...EntityValueFields }\n      organisationRoles { ...EntityValueFields }\n    "], ["\n      id\n      name\n      slug\n      description { id text html }\n      startDate\n      endDate\n      url\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n\n      banner { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      links { ...EntityValueFields }\n      documents { ...EntityValueFields }\n      quotes { ...EntityValueFields }\n      roles { ...EntityValueFields }\n      organisationRoles { ...EntityValueFields }\n    "])))
  }
};
var templateObject_1;